// Global
export const LOAD_SETTINGS = 'loadSettings';

// Page
export const CREATE_COMPONENT = 'createComponent';
export const EXECUTE_WORKFLOW = 'executeWorkflow';
export const LOAD_COMPONENT_TREE = 'loadComponentTree';
export const LOAD_PAGE = 'loadPage';
export const LOAD_PRESETS = 'loadPresets';
export const LOAD_PROTOTYPES = 'loadPrototypes';
export const LOAD_TEMPLATES = 'loadTemplates';
export const POLL_CONNECTIVITY = 'pollConnectivity';
export const LOAD_WORKFLOW_STEPS = 'loadWorkflowSteps';
export const PUBLISH_ITEM = 'publishItem';
export const SAVE_LANGUAGE_VERSION = 'saveLanguageVersion';
export const SAVE_PAGE = 'savePage';
export const SAVE_COMPONENT = 'saveComponent';
export const SAVE_SETTINGS = 'saveSettings';
export const TOGGLE_LOCK = 'toggleLock';

// User
export const AUTHENTICATE = 'authenticate';
export const GET_USER = 'getUser';
export const GET_USERNAME = 'getUsername';
export const LOGOUT = 'logout';
